import { Box, Container, Toolbar, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AlertDialog from 'components/AlertDialog';
import useConfig from 'hooks/useConfig';
import AllUsersGlobalListeners from 'layout/MainLayout/Listeners/AllUsersGlobalListeners';
import { Outlet } from 'react-router-dom';
import { MenuOrientation } from 'types/config';
import Drawer from './Drawer';
import HorizontalBar from './Drawer/HorizontalBar';
import Header from './Header';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));
  const { container, menuOrientation } = useConfig();
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  return (
    <>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Header />
        {!isHorizontal ? <Drawer /> : <HorizontalBar />}

        <Box
          component="main"
          sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 0.5, sm: 1 }, mt: 1 }}
        >
          <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit', p: 0, minHeight: 48 }} />
          <Container
            maxWidth={container ? 'xl' : false}
            sx={{
              ...{ px: { xs: 0, sm: 0 } },
              position: 'relative',
              minHeight: 'calc(100vh - 110px)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Outlet />
          </Container>
          <AlertDialog />
        </Box>
      </Box>
      <AllUsersGlobalListeners />
      <AlertDialog />
    </>
  );
};

export default MainLayout;
